import scrollDir from "scrolldir";
import { invalidInputFocus } from "../../../shared/components/form/js/invalidInputFocus";
import { AccordionItems } from "../../../shared/components/accordion-item";
import "./js/scrolltoelement";

document.addEventListener("DOMContentLoaded", () => {
  new invalidInputFocus();
  new AccordionItems();
  scrollDir();
});
